import React, { useState, useRef, useEffect } from "react";
import { Button, Icon } from "antd";
import { ReactComponent as ThumbnailPlaceholder } from '../../assets/svg/thumbnailPlaceholder.svg'
import { Http } from '../../helpers/axois'
import "./widgets/styles/upload-thumbnail.scss";
import { GCPENDPOINT } from "../../constant/common";
import { useToast } from '../../helpers/commonFunction';
import { logger } from "../../constant/winston";
import { beforeUpload } from "../../helpers/fileHelper";

interface IProps {
  setThumbnail: (key: string, value: any) => void;
  orgId: string;
  info?: any;
  setInfo?: any;
  fromFunction?: boolean;
}

const UploadThumbnail: React.FC<IProps> = ({ setThumbnail, orgId, info, setInfo, fromFunction=false }) => {
  const { previewImage } = info;
  const inputRef: any = useRef(null);
  const [preview, setPreview] = useState(previewImage);
  const [isPreviewImageDelete, SetIsPreviewImageDelete] = useState<boolean>(false);
  const { SuccessToast, ErrorToast } = useToast();

  const handleInputTrigger = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.click();
    }
  };

  useEffect(() => {
    if (previewImage && !(previewImage?.includes('https://'))) {
      setPreview(GCPENDPOINT + previewImage)
    } else if (previewImage && (previewImage?.includes('https://'))) {
      setPreview(previewImage)
    } else {
      setPreview("")
      SetIsPreviewImageDelete(true)
    }
  }, [previewImage])

  const handleInputChange = async (e: any) => {
    if (e.target.files.length) {
      const file = e.target.files[0];
      const formData = new FormData();
      const name = `${Math.random()
        .toString(36)
        .substring(2)}-${Date.now().toString(36)}_${file.name}`;
      formData.append("file", file, name);
      const shoudUpload = beforeUpload(file)
      if (shoudUpload.ok) {
        try {
          const res: any = await Http.post(`/orgs/${orgId}/store/products/image/upload`, formData).toPromise();
          setThumbnail('previewImage', res.url)
          SuccessToast("Thumbnail uploaded");
          SetIsPreviewImageDelete(false)
        } catch (e) {
          logger.error(e)
          ErrorToast("Thumbnail upload failed");
        }
      } else {
        ErrorToast(shoudUpload.message)
      }
    }
  }

  const handleFileDelete = (fileName: string) => {
    const endpoint = `/orgs/${orgId}/store/products/image/remove`
    setInfo((prevState: any) => ({ ...prevState, previewImage: "" }))
    Http.put(endpoint, { data: { files: { fileName } } }).subscribe((res: any) => {
      SuccessToast("Deleted screenshot")
      SetIsPreviewImageDelete(true)
    }, (err) => {
      logger.error(err)
      // ErrorToast(err.message)
    })
  }

  return (
    <div className="upload-thumbnail">
      <h5>{!fromFunction ? "Application Preview Image" : "Function Preview Image"}</h5>
      <div className="upload-thumbnail-content">
        <div style={{ position: "relative" }}>
          <div className="upload-thumbnail-holder">
            {!preview ? <ThumbnailPlaceholder /> : <img src={preview} alt="Thumbnail preview" />}
            {!isPreviewImageDelete &&
              <Icon
                type="delete"
                title="delete"
                className="action-wrapper"
                onClick={(e) => {
                  SetIsPreviewImageDelete(true)
                  e.stopPropagation();
                  handleFileDelete(previewImage);
                }}
              />
            }
          </div>
        </div>
        <input
          data-test-id="upload_thumbnail_input"
          type="file"
          style={{ display: "none" }}
          ref={inputRef}
          onChange={handleInputChange}
          accept="image/*"
        />
        <Button data-test-id="upload_thumbnail" onClick={handleInputTrigger}>Upload Thumbnail</Button>
      </div>
    </div>
  );
};

export default UploadThumbnail;
